export default "__VITE_ASSET__CQUj20DB__"